import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useDispatch } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import logout from "../assets/images/logouticon.png";
import "./Sidebar.css";
import { clearAuth } from "../../redux/auth/slice";


const LogoutButton = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch();

  const toggleModal = () => setModalOpen(!modalOpen);

  const handleLogout = () => {
    dispatch(clearAuth());
    window.location.href = "/";
  };

  return (
    <div className="">
       
       <div className="tooltip-wrapper">
  <button style={{ background: "none", border: "none" }} className="p-0" onClick={toggleModal}>
    <img src={logout} height={"22px"} width={"22px"} alt="Logout icon" />
  </button>
  <span className="custom-tooltip-logout">Logout</span>
</div>




      <Modal isOpen={modalOpen} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Confirm Logout</ModalHeader>
        <ModalBody>
         Are you sure you want to log out ?
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Close
          </Button>
          <Button className="btn btn-danger" onClick={handleLogout}>
            Logout
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default LogoutButton;
